import { Schema } from "effect";
import { HttpApiEndpoint, HttpApiError, HttpApiGroup, HttpApiSchema } from "effect/http-api";
import { OneFileSchema } from "../multipart.js";

const SixSenseUploadPayloadSchema = Schema.Struct({
  iso3166: Schema.String,
  file: OneFileSchema,
}).pipe(HttpApiSchema.asMultipart());

export const SixSenseUploadResponseSchema = Schema.Struct({
  success: Schema.Boolean,
});

export const SixSenseV3Group = HttpApiGroup.make("sixSenseV3").add(
  HttpApiEndpoint.post("importCsv", "/6sense", {
    payload: SixSenseUploadPayloadSchema,
    success: SixSenseUploadResponseSchema.pipe(HttpApiSchema.status(201)),
    error: [HttpApiError.BadRequestNoContent, HttpApiError.InternalServerErrorNoContent],
  })
);
